import React from 'react';
import SensorReportPage from './SensorReportPage';
import { connect } from 'react-redux';
import { reportActions } from '../../../../actions/report.actions';

class SensorReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.report.isSubmitting !== prevState.isSubmitting) {
      state.isSubmitting = nextProps.report.isSubmitting;
    }
    return Object.keys(state).length ? state : null;
  }
  setReportExportOption = (format) => {
    this.props.downloadReport(format);
  };
  render() {
    const { isSubmitting } = this.state;
    return (
      <SensorReportPage
        onClick={this.setReportExportOption}
        isSubmitting={isSubmitting}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    report: state.report,
  };
}

export default connect(mapStateToProps, reportActions)(SensorReport);
